import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { blogService } from '../../services/blogService';
import AdminLayout from '../../components/AdminLayout';

const AdminDashboardHome = () => {
    const [blogs, setBlogs] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        loadBlogs();
    }, []);

    const loadBlogs = async () => {
        try {
            const data = await blogService.getAllBlogsAdmin();
            setBlogs(data);
        } catch (err) {
            console.error('Error loading blogs:', err);
        }
    };

    // Dashboard stats
    const stats = [
        { label: 'Total Blogs', value: blogs.length, icon: '📝', color: '#C9A96E' },
        { label: 'Published', value: blogs.filter(b => b.published).length, icon: '✅', color: '#28a745' },
        { label: 'Drafts', value: blogs.filter(b => !b.published).length, icon: '📄', color: '#ffc107' }
    ];

    return (
        <AdminLayout>
            <div>
                {/* Stats Cards */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                    gap: '24px',
                    marginBottom: '40px'
                }}>
                    {stats.map((stat, index) => (
                        <div
                            key={index}
                            style={{
                                background: 'linear-gradient(135deg, rgba(201, 169, 110, 0.1) 0%, rgba(201, 169, 110, 0.05) 100%)',
                                border: '1px solid rgba(201, 169, 110, 0.2)',
                                borderRadius: '16px',
                                padding: '30px',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.borderColor = stat.color;
                                e.currentTarget.style.boxShadow = `0 10px 30px ${stat.color}40`;
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.borderColor = 'rgba(201, 169, 110, 0.2)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                                <span style={{ fontSize: '40px' }}>{stat.icon}</span>
                                <div style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    background: `${stat.color}20`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <span style={{ fontSize: '24px' }}>📈</span>
                                </div>
                            </div>
                            <div style={{ fontSize: '36px', fontWeight: '600', color: stat.color, marginBottom: '8px' }}>
                                {stat.value}
                            </div>
                            <div style={{ fontSize: '14px', color: 'rgba(245, 241, 237, 0.7)', letterSpacing: '0.5px' }}>
                                {stat.label}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Quick Actions */}
                <div style={{
                    background: 'linear-gradient(135deg, rgba(201, 169, 110, 0.08) 0%, rgba(201, 169, 110, 0.03) 100%)',
                    border: '1px solid rgba(201, 169, 110, 0.2)',
                    borderRadius: '16px',
                    padding: '30px',
                    marginBottom: '40px'
                }}>
                    <h2 style={{ fontSize: '24px', fontWeight: '300', marginBottom: '24px', color: 'var(--text-light)' }}>
                        Quick Actions
                    </h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                        <button
                            onClick={() => navigate('/admin/blogs')}
                            style={{
                                padding: '20px',
                                background: 'rgba(201, 169, 110, 0.1)',
                                border: '1px solid rgba(201, 169, 110, 0.3)',
                                borderRadius: '12px',
                                color: 'var(--accent-color)',
                                fontSize: '15px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = 'rgba(201, 169, 110, 0.2)';
                                e.target.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = 'rgba(201, 169, 110, 0.1)';
                                e.target.style.transform = 'translateY(0)';
                            }}
                        >
                            <span style={{ fontSize: '24px' }}>📝</span>
                            <span>Create New Blog</span>
                        </button>
                        <button
                            onClick={() => navigate('/admin/instagram')}
                            style={{
                                padding: '20px',
                                background: 'rgba(201, 169, 110, 0.1)',
                                border: '1px solid rgba(201, 169, 110, 0.3)',
                                borderRadius: '12px',
                                color: 'var(--accent-color)',
                                fontSize: '15px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = 'rgba(201, 169, 110, 0.2)';
                                e.target.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = 'rgba(201, 169, 110, 0.1)';
                                e.target.style.transform = 'translateY(0)';
                            }}
                        >
                            <span style={{ fontSize: '24px' }}>📸</span>
                            <span>Sync Instagram</span>
                        </button>
                        <button
                            onClick={() => window.open('/', '_blank')}
                            style={{
                                padding: '20px',
                                background: 'rgba(201, 169, 110, 0.1)',
                                border: '1px solid rgba(201, 169, 110, 0.3)',
                                borderRadius: '12px',
                                color: 'var(--accent-color)',
                                fontSize: '15px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = 'rgba(201, 169, 110, 0.2)';
                                e.target.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = 'rgba(201, 169, 110, 0.1)';
                                e.target.style.transform = 'translateY(0)';
                            }}
                        >
                            <span style={{ fontSize: '24px' }}>🌐</span>
                            <span>View Website</span>
                        </button>
                    </div>
                </div>

                {/* Recent Blogs */}
                <div style={{
                    background: 'linear-gradient(135deg, rgba(201, 169, 110, 0.08) 0%, rgba(201, 169, 110, 0.03) 100%)',
                    border: '1px solid rgba(201, 169, 110, 0.2)',
                    borderRadius: '16px',
                    padding: '30px'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: '300', color: 'var(--text-light)' }}>
                            Recent Blogs
                        </h2>
                        <button
                            onClick={() => navigate('/admin/blogs')}
                            style={{
                                padding: '8px 16px',
                                background: 'transparent',
                                border: '1px solid var(--accent-color)',
                                borderRadius: '8px',
                                color: 'var(--accent-color)',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = 'var(--accent-color)';
                                e.target.style.color = '#000';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = 'transparent';
                                e.target.style.color = 'var(--accent-color)';
                            }}
                        >
                            View All →
                        </button>
                    </div>
                    {blogs.slice(0, 5).map((blog) => (
                        <div
                            key={blog._id}
                            style={{
                                padding: '20px',
                                background: 'rgba(255, 255, 255, 0.03)',
                                borderRadius: '12px',
                                marginBottom: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                                e.currentTarget.style.transform = 'translateX(5px)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                                e.currentTarget.style.transform = 'translateX(0)';
                            }}
                        >
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: '16px', fontWeight: '500', color: 'var(--text-light)', marginBottom: '8px' }}>
                                    {blog.title}
                                </div>
                                <div style={{ fontSize: '13px', color: 'rgba(245, 241, 237, 0.6)' }}>
                                    {new Date(blog.createdAt).toLocaleDateString()}
                                </div>
                            </div>
                            <span style={{
                                padding: '6px 12px',
                                borderRadius: '20px',
                                fontSize: '12px',
                                fontWeight: '600',
                                background: blog.published ? 'rgba(40, 167, 69, 0.2)' : 'rgba(255, 193, 7, 0.2)',
                                color: blog.published ? '#28a745' : '#ffc107'
                            }}>
                                {blog.published ? 'Published' : 'Draft'}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </AdminLayout>
    );
};

export default AdminDashboardHome;

